export interface PlacementItem {
  id: string | number;
  itemgroup?: { id: string } | null;
}

export function getVisiblePlacementNeighbors<T extends PlacementItem>(
  visibleItems: T[],
  item: PlacementItem,
): { previous: T | null; next: T | null } {
  const groupItems = visibleItems.filter(
    (candidate) => (candidate.itemgroup?.id ?? null) === (item.itemgroup?.id ?? null),
  );
  const index = groupItems.findIndex((candidate) => String(candidate.id) === String(item.id));
  return {
    previous: index > 0 ? groupItems[index - 1] : null,
    next: index >= 0 ? groupItems[index + 1] ?? null : null,
  };
}
